import { writable, readable } from 'svelte/store';

export let colorMain = writable("#32292F");
export let height = writable(window.innerHeight);
export let debug = readable(false);
export let popup = writable(true);  // whether to show popup modal when feed loads
export let formSubmitted = writable(false);  // whether form has been submitted
export let inviewIdx = writable(true);  // which card index is currently inview
export let engageButtons = writable([]); // which engage buttons to show

// feed infinite scroll
export let entities = writable({});
export let entitiesSplit = writable([]);
export let entitiesArray = writable([]);
export let entitiesPages = writable(0);

// paths/endpoints
// see https://github.com/zivepstein/yourfeed-backend
// const host = "https://www.yourfeed.social";
// const host = "https://foodcam20.media.mit.edu";
// const host = "http://165.22.10.182";
const host = "https://octopus-app-pu4mk.ondigitalocean.app"
// const host = "https://yourfeedser/ver.xyz"
// const host = "http://127.0.0.1:5123";  // local flask app

export let api_feed = readable(host + "/v1/load_experiment");
export let api_engage = readable(host + "/v1/write_user_engagement");
export let api_dumpData = readable(host + "/v1/dump_data");
export let api_writeDwell = readable(host + "/v1/write_batch_dwell");
export let api_writeForm = readable(host + "/v1/write_form");
export let api_spawnExperiment = readable(host + "/v1/spawn_experiment");
export let api_pullEntitySets = readable(host + "/v1/pull_entity_sets");
export let api_ingestEntitySet = readable(host + "/v1/ingest_entity_set");
export let api_analytics = readable(host + "/v1/analytics");

// use userAgent info to determine whether to disable/enable submit/next form buttons
let userAgent = navigator.userAgent.toLowerCase();
console.log("userAgent", userAgent);
export let userAgentInfo = readable(userAgent);
export let disableNextButton = writable(true);
// if (userAgent.includes("mobile") || localStorage.getItem("experiment_id") == "solarflare" || localStorage.getItem("experiment_id") === null) {
// 	console.log("next buttons always enabled");
// 	disableNextButton = writable(false);
// }

// exclude sets
export let excludeSets = readable([
	"22may18_climate",
	"22051852_climatechange",
	"22051857_fakenews",
	"22apr25_youtube_pop",
	"22052625_mon",
	"22052625_mo",
	"22052625_m",
	"22052809_monkeypox",
	"22052625_youtubepopular",
	"22052817_youtubepopular",
	"23021502_fakenews",
	"23021348_fakenews",
	"23021507_benlukevideos",
	"23021513_benluke4",
	"23021511_benlukevid",
	"23021528_benluke4"
]);

// map form name/title to form route
export let formMap = readable({
	"cognitive reflection (6-items)": "/form/crt",
	"political ideology": "/form/lean",
	"social media usage": "/form/socialmediause",
	"socioeconomic status": "/form/ses",
	"demographics": "/form/form",
	"news importance": "/form/imp",
	"attention check": "/form/ac",
	"actively-open-thinking": "/form/aot",
	"climate change concern": "/form/ccn",
	"climate change desire freq": "/form/def",
	"climate change exposure freq": "/form/exp",
	"COVID-19 fatigue": "/form/ftg",
	"final debrief (random-time-comments)": "/form/final",
	"custom end messsage": "/form/custom-msg"
});

